import React, { useMemo } from 'react';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { classnames } from '@bydesign-ui/utils';
import { RcCascaderProvider } from '../../hooks/tree';
import { Empty } from '../empty';
import { RootNode } from './components/RootNode';
import { TreeInfoContext } from './context/TreeInfoContext';
export function BaseTree(props) {
  var _props$blockNode = props.blockNode,
      blockNode = _props$blockNode === void 0 ? true : _props$blockNode,
      className = props.className,
      style = props.style,
      disabled = props.disabled,
      showLine = props.showLine,
      nodeKey = props.nodeKey,
      renderIcon = props.renderIcon,
      renderItem = props.renderItem,
      multiple = props.multiple,
      search = props.search,
      cascader = props.cascader,
      filterTreeNode = props.filterTreeNode;
  var treeInfo = {
    showLine: showLine,
    renderIcon: renderIcon,
    renderItem: renderItem,
    search: search
  };
  useMemo(function () {
    if (search !== undefined) {
      cascader.setTreeSearch(search, filterTreeNode);
    }
  }, [search, filterTreeNode]);
  var localeEmpty = useLocale('transfer.empty');
  var cls = classnames(usePrefixCls('tree', {
    disabled: disabled,
    multiple: multiple,
    'multiple-line': !blockNode
  }), className);
  var emptyCls = usePrefixCls('tree-empty');
  var treeSearchMatchNodes = cascader.treeSearchMatchNodes;

  if (treeSearchMatchNodes && treeSearchMatchNodes.length === 0) {
    return React.createElement("div", {
      className: emptyCls,
      style: style
    }, React.createElement(Empty, {
      content: localeEmpty
    }));
  }

  return React.createElement(TreeInfoContext.Provider, {
    value: treeInfo
  }, React.createElement(RcCascaderProvider, {
    cascader: cascader
  }, React.createElement("div", {
    className: cls,
    style: style,
    onDragLeave: function onDragLeave() {
      cascader.setEnterID('');
    }
  }, React.createElement(RootNode, {
    nodeKey: nodeKey
  }))));
}